import React, { useState, useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "https://go.brandhives.com";
const G = "#0077B5";

export default function FiltersTab({ user, onNavigateBilling }) {
  const [contentFilters, setContentFilters] = useState([]);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [filterInput, setFilterInput] = useState("");
  const [filterAdding, setFilterAdding] = useState(false);

  const plan = (user?.plan || "free").toLowerCase();
  const filterLimit = plan === "authority" || plan === "authority_pro" || plan === "team" || plan === "team_member" || plan === "agency" || plan === "authority_team" || plan === "authority_team_member" || plan === "pro_team" || plan === "pro_team_member" ? 25 : plan === "presence" ? 10 : 0;

  useEffect(() => {
    if (filterLimit === 0) return;
    setFiltersLoading(true);
    fetch(`${API_BASE}/app/api/user/content-filters`, { credentials: "include" })
      .then(r => r.ok ? r.json() : { filters: [] })
      .then(d => setContentFilters(d.filters || []))
      .catch(() => {})
      .finally(() => setFiltersLoading(false));
  }, [filterLimit]);

  const addFilter = async () => {
    if (!filterInput.trim() || filterAdding || contentFilters.length >= filterLimit) return;
    setFilterAdding(true);
    try {
      const r = await fetch(`${API_BASE}/app/api/user/content-filters`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ term: filterInput.trim() }),
      });
      const d = await r.json();
      if (d.filter) {
        setContentFilters(f => [...f, d.filter]);
        setFilterInput("");
      }
    } catch { /* handled */ }
    setFilterAdding(false);
  };

  const deleteFilter = async (filterId) => {
    setContentFilters(f => f.filter(x => x.id !== filterId));
    try {
      await fetch(`${API_BASE}/app/api/user/content-filters/${filterId}`, { method: "DELETE", credentials: "include" });
    } catch { /* best effort */ }
  };

  return (
    <div>
      <div style={{ fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 12, letterSpacing: "0.2em", color: "#999999", textTransform: "uppercase", marginBottom: 16 }}>Content Filters</div>
      <div style={{ fontSize: 14, color: "#444", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", marginBottom: 16, lineHeight: 1.6 }}>
        Terms or topics you add here will be excluded from your article feed and won't appear in your captions.
      </div>
      {filterLimit === 0 ? (
        <div style={{ background: "#FFF9EC", border: "1px solid #F6D860", borderRadius: 10, padding: "16px 20px", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: "#7A5200", marginBottom: 4 }}>Content filters require Presence or higher</div>
          <div style={{ fontSize: 13, color: "#92400E", marginBottom: 12 }}>Upgrade to exclude specific topics or terms from your posts. Presence gets 10 filters, Authority gets 25.</div>
          <button onClick={onNavigateBilling} style={{ background: "#F59E0B", color: "#fff", border: "none", borderRadius: 6, padding: "8px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>Upgrade →</button>
        </div>
      ) : (
        <>
          <div style={{ fontSize: 12, color: "#999", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", marginBottom: 12 }}>{contentFilters.length} / {filterLimit} filters used</div>
          <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
            <input value={filterInput} onChange={e => setFilterInput(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter") addFilter(); }}
              placeholder="e.g. crypto, politics, AI"
              style={{ flex: 1, border: "1px solid #E1E9EE", borderRadius: 8, padding: "10px 14px", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 14, outline: "none" }} />
            <button onClick={addFilter} disabled={filterAdding || !filterInput.trim() || contentFilters.length >= filterLimit}
              style={{ background: (!filterInput.trim() || filterAdding || contentFilters.length >= filterLimit) ? "#ccc" : G, color: "#fff", border: "none", borderRadius: 8, padding: "10px 16px", fontSize: 14, fontWeight: 600, cursor: (!filterInput.trim() || filterAdding || contentFilters.length >= filterLimit) ? "not-allowed" : "pointer", whiteSpace: "nowrap", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
              {filterAdding ? "Adding…" : "Add"}
            </button>
          </div>
          {filtersLoading ? (
            <div style={{ fontSize: 13, color: "#999", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>Loading…</div>
          ) : contentFilters.length === 0 ? (
            <div style={{ fontSize: 13, color: "#999", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>No filters yet. Add a term above to get started.</div>
          ) : (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {contentFilters.map(f => (
                <div key={f.id} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#F0F7FF", border: "1px solid #B3D4E8", borderRadius: 20, padding: "5px 12px", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 13 }}>
                  <span style={{ color: "#005885" }}>{f.term}</span>
                  <button onClick={() => deleteFilter(f.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "#999", fontSize: 16, lineHeight: 1, padding: "0 0 1px 2px" }}>×</button>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
